import './instrument.ts'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { installAiAnalyticsFetchGuard } from '@/lib/api/aiCreditsGuard'
import { isSandboxMode } from '@/sandbox/env'

installAiAnalyticsFetchGuard()

if (typeof document !== 'undefined') {
  const blockWheel = (e: WheelEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  document.addEventListener(
    'focusin',
    (e) => {
      const t = e.target as HTMLElement | null;
      if (t && t instanceof HTMLInputElement && t.type === 'number') {
        t.addEventListener('wheel', blockWheel, { passive: false });
      }
    },
    true,
  );
  document.addEventListener(
    'focusout',
    (e) => {
      const t = e.target as HTMLElement | null;
      if (t && t instanceof HTMLInputElement && t.type === 'number') {
        t.removeEventListener('wheel', blockWheel);
      }
    },
    true,
  );
}

async function bootstrap() {
  if (isSandboxMode()) {
    const { installSandbox } = await import('@/sandbox');
    await installSandbox();
  }
  createRoot(document.getElementById("root")!).render(<App />);
}

void bootstrap();
